import { createStore, compose, applyMiddleware, Store } from 'redux';
import createSagaMiddleware, { END } from 'redux-saga';
import createRavenMiddleware from 'raven-for-redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory, createMemoryHistory } from 'history';

import reducer, { State } from './root-reducer';
import rootSaga from './root-saga';

export { State };

// Хелпер, помогающий определить, в какой среде находимся
export const isServer = !(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
);

export interface ReduxStore extends Store {
    runSaga: any;
    close(): void;
}

export default function configureStore(initialState = {}, url = '/') {
    const history = isServer
        ? createMemoryHistory({ initialEntries: [url] })
        : createBrowserHistory();

    const sagaMiddleware = createSagaMiddleware();
    const composeEnhancers = getComposeEnhancers();
    const middlewares = [
        routerMiddleware(history),
        getRavenMiddleware() as any,
        sagaMiddleware
    ].filter(Boolean);

    const store = createStore(
        connectRouter(history)(reducer),
        initialState,
        composeEnhancers(applyMiddleware(...middlewares))
    ) as ReduxStore;

    if (!isServer) {
        sagaMiddleware.run(rootSaga);
    }

    // Методы, используемые в серверном рендеринге
    // для запуска и остановки саги
    store.runSaga = sagaMiddleware.run;
    store.close = () => store.dispatch(END);

    return { store, history };
}

function getComposeEnhancers() {
    if (process.env.NODE_ENV === 'local' && !isServer) {
        return (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    }

    return compose;
}

function getRavenMiddleware() {
    if (!isServer) {
        return createRavenMiddleware(Raven);
    }
}
